export const url = '/platformserver/';